import React, { useState } from "react";
import { ProCard } from "@ant-design/pro-components";
import { Card, Space } from "antd";
import { Toast } from "antd-mobile";
import classNames from "classnames";
import { formatDate, formatData } from "../../utils/utils";
import { fileDownload } from "../../services/services";
import { createFromIconfontCN } from "@ant-design/icons";
import CardDetail from "../CardDetail";
import styles from "./index.module.css";

// 创建自定义图标组件
const IconFont = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_4247980_ew505ze2oms.js",
});

// StandardCard 组件用于展示标准卡片内容
export default function StandardCard({ data, category }) {
  const { name, size, release_date, doc_id, external_url = "" } = data;
  const [collapsed, setCollapsed] = useState(true);

  // 根据是否展开和卡片类型确定样式类名
  const flag =
    !collapsed && (category === "firmware" || category === "DeveloperTools");
  const clickedClass = flag
    ? {
        title: classNames(styles.title, styles.active),
        clicked: { backgroundColor: "#214554" },
        icon: classNames(styles.icon, styles.active),
        timeType: "icon-TimeCircle-copy",
        sizeType: "icon-folderopen-copy",
        downloadType: "icon-download-copy",
      }
    : {
        title: styles.title,
        clicked: null,
        icon: styles.icon,
        timeType: "icon-TimeCircle",
        sizeType: "icon-folderopen",
        downloadType: "icon-download",
      };

  // 定义卡片标题内容
  const title = (
    <div>
      <Card bodyStyle={clickedClass.clicked}>
        <div>
          <div className={clickedClass.title}>{name}</div>
          <Space size="large">

            <div className={clickedClass.icon}>
              <IconFont
                type={clickedClass.timeType}
                style={{ fontSize: 20 }}
                className={styles.icon}
              />
              &nbsp;&nbsp;
              <span>{formatDate(release_date)}</span>
            </div>
            <div className={clickedClass.icon}>
              <IconFont
                type={clickedClass.sizeType}
                style={{ fontSize: 20 }}
              />
              &nbsp;&nbsp;
              <span>{formatData(parseFloat(size))}</span>
            </div>
          </Space>
        </div>
      </Card>
    </div>
  );

  // 处理下载操作
  async function handleDownload() {
    if (external_url !== "") {
      window.location.href = external_url;
    } else {
      const res = await fileDownload(doc_id, { verbose: 100 });
      if (res.status === 200) {
        window.location.href = res.result.url;
      } else {
        Toast.show({
          content: res.error,
          duration: 3000,
        });
      }
    }
  }

  // 渲染卡片组件
  return (
    <ProCard
      headStyle={clickedClass.clicked}
      title={title}
      bordered
      headerBordered
      collapsed={collapsed}
      onClick={() => setCollapsed(!collapsed)}
      extra={
        <IconFont
          type={clickedClass.downloadType}
          style={{ fontSize: 28, padding: "2.564vw" }}
          onClick={handleDownload}
        />
      }
    >
      {category === "DeveloperTools" || category === "firmware" ? (
        <CardDetail data={data} />
      ) : null}
    </ProCard>
  );
}
